import { SET_MODE, SET_SELECTED_NODE, SET_NODES,SET_CLONE_NAME } from '../actions/actions';

// Initial State
const initialState = {
  mode: 'view',
  selectedNodeId: null,
  nodes: [],
  clonedTemplateName:''
};

// Reducer
export default function workflowReducer(state = initialState, action) {
  switch (action.type) {
    case SET_MODE:
      return {
        ...state,
        mode: action.payload,
      };
    case SET_SELECTED_NODE:
      return {
        ...state,
        selectedNodeId: action.payload,
      };
    case SET_NODES:
      return {
        ...state,
        nodes: action.payload,
      };
    case SET_CLONE_NAME:
      return {
        ...state,
        clonedTemplateName: action.payload,
      };
    default:
      return state;
  }
}
